<template>
    <main-layout class="bg-gray-100 min-h-screen flex flex-col list-bouteilles" id="bottle_page">

        <!-- En-tête + CTA + recherche + filtres, dans UN SEUL bloc -->
        <div class="bg-gradient-to-b from-secondary to-primary">
            <div class="p-2 space-y-3">
                <app-header icon="bouteille" class="text-white">
                    <div class="flex items-center justify-between">
                        <h1 class="text-2xl font-semibold tracking-wide">Bouteille</h1>
                    </div>
                </app-header>

                <action-bar :back="{ name: 'liste-bouteilles' }" class="!p-0 !m-0">
                    <a v-if="!this.isRestit && this.bouteille.actif === true"
                        class="inline-flex items-center gap-2 bg-white text-primary text-sm font-medium px-4 py-2 rounded-lg shadow-sm hover:shadow transition main-action cloturer"
                        href="javascript: void 0" @click="modifBouteilleStatus">
                        <i class="inline-block h-6 w-6 mask mask-otag bg-primary"></i>
                        <span>
                            <strong>Clôturer</strong> la bouteille
                        </span>
                    </a>
                    <a v-if="!this.isRestit && this.bouteille.actif === false"
                        class="inline-flex items-center gap-2 bg-white text-primary text-sm font-medium px-4 py-2 rounded-lg shadow-sm hover:shadow transition main-action rendre"
                        href="javascript: void 0" @click="modifBouteilleStatus">
                        <i class="inline-block h-6 w-6 mask mask-otag bg-primary"></i>
                        <span>
                            <strong>Rendre</strong> la bouteille
                        </span>
                    </a>
                </action-bar>
                <!-- Section recherche / filtres -->
                <section class="px-8 pb-15">
                    <!-- Nom de la bouteille -->
                    <div class="flex flex-col md:flex-row items-start md:items-center gap-1 ">
                        <p v-if="this.bouteille.favori !== null && this.bouteille.favori !== undefined && this.bouteille.favori.id === $user.id">
                            <i class="inline-block h-6 w-6 bg-[#f9d342] mask mask-star"></i>
                        </p>

                        <!-- Titre : 1 ligne -->
                        <h2 class="text-4xl font-bold text-gris-bleu whitespace-nowrap">
                            <span id="nombouteille" v-if="bouteille.nom">{{ bouteille.nom.nom }}</span>
                        </h2>

                        <!-- Poids : passe en dessous en mobile -->
                        <span class="text-gray-400 text-lg font-bold md:ml-2 whitespace-nowrap" id="poidsmax"
                            data-max="10">
                            ( {{ bouteille.poids_max }} Kg )
                        </span>
                    </div>

                    <!-- Distributeur -->
                    <small class="text-gray-300 text-lg" id="typebouteille">{{ bouteille.type }}</small>
                    <p class="text-xl text-white uppercase mb-4" id="distributeur" v-if="bouteille.fournisseur">{{
                        bouteille.fournisseur.nom }}</p>

                    <div class="flex flex-wrap items-center gap-4 pb-6 w-[70%]">

                        <div v-if="bouteille.fluide"
                            class="flex-none flex items-center gap-2 px-3 py-1 rounded-xl text-white text-md font-medium"
                            :class="bouteille.type === 'Fluide frigorigène' ? 'bg-gaz-ff' : (bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')">
                            <!-- Wrapper pour isoler le mask -->
                            <div class="relative flex items-center">
                                <i class="inline-block h-6 w-6 bg-white mask mask-snow"></i>
                            </div>

                            <span>{{ bouteille.fluide.nom }}</span>

                            <span v-if="bouteille.fluide.regenerated"
                                class="inline-block h-4 w-4 rounded-full bg-warning ml-1"
                                title="Fluide régénéré"></span>
                        </div>

                        <div class="flex-none flex items-center gap-2 px-3 py-1 rounded-xl bg-white text-md font-medium"
                            :class="bouteille.type === 'Fluide frigorigène' ? 'text-gaz-ff' : (bouteille.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')">
                            <i class="inline-block h-6 w-6 mask mask-bouteille"
                                :class="bouteille.type === 'Fluide frigorigène' ? 'bg-gaz-ff' : (bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')"></i>
                            <span>{{ bouteille.code }}</span>
                        </div>


                        <div v-if="bouteille.otag"
                            class="flex-none flex items-center gap-2 px-3 py-1 rounded-xl bg-white text-md font-medium"
                            :class="bouteille.type === 'Fluide frigorigène' ? 'text-gaz-ff' : (bouteille.type === 'Récupération' ? 'text-gaz-rec' : 'text-gaz-tf')">
                            <i class="inline-block h-6 w-6 mask mask-otag"
                                :class="bouteille.type === 'Fluide frigorigène' ? 'bg-gaz-ff' : (bouteille.type === 'Récupération' ? 'bg-gaz-rec' : 'bg-gaz-tf')"></i>
                            <span>{{ bouteille.otag }}</span>
                        </div>
                    </div>
                </section>
            </div>
        </div>


        <div id="bouteille"
            class="bg-gradient-to-b from-[#F8FBFF] to-[#E2E9F5] rounded-t-3xl -mt-6 flex-1 shadow-xl pb-28">
            <div class="p-4">
                <!-- Bloc tare, tare+net, retour prévu, bouteille à droite -->
                <div class="flex items-start justify-between">
                    <!-- Texte à gauche -->
                    <div class="space-y-2" id="bottle_infos_left" style="width: 300px">
                        <div class="font-bold text-alert" v-if="bouteille.actif === false">
                            <strong>BOUTEILLE CLOTURÉE</strong>
                        </div>

                        <div class="font-bold text-alert uppercase" v-if="this.isRestit">
                            <strong>Bouteille restituée</strong>
                        </div>

                        <div class="p-5 rounded-xl border shadow-sm bg-white/80 backdrop-blur-sm border-gray-100">
                            <div class="space-y-3">

                                <div class="flex justify-between items-center">
                                    <span class="text-sm font-medium text-gray-500">Poids total de fluide</span>
                                    <span class="text-lg font-semibold text-gray-800">{{ bouteille.poids_net }}
                                        Kg</span>
                                </div>

                                <div v-if="bouteille.tare" class="flex justify-between items-center">
                                    <span class="text-sm font-medium text-gray-500">Tare</span>
                                    <span class="text-lg font-semibold text-gray-800">{{ (bouteille.tare).toFixed(2) }}
                                        Kg</span>
                                </div>

                                <div v-if="bouteille.tare"
                                    class="flex justify-between items-center pt-3 border-t border-gray-100">
                                    <span class="text-sm font-medium text-secondary">Total</span>
                                    <span class="text-xl font-bold text-secondary">{{ getPoidsBrut(bouteille.tare,
                                        bouteille.poids_net) }} Kg</span>
                                </div>

                                <div v-if="bouteille.ref_livraison !== null" class="mt-4 pt-3 border-t border-gray-100">
                                    <div class="flex justify-between items-center">
                                        <span class="text-sm font-medium text-gray-500">Référence</span>
                                        <span class="text-lg font-mono font-semibold text-gray-700" id="reference">
                                            {{ refLivraisonTruncate }}
                                        </span>
                                    </div>
                                </div>

                            </div>
                        </div>




                        <p class="text-lg text-gray-700 mt-4">
                            Retour prévu :
                        </p>
                        <div class="flex items-center gap-2 mb-4">
                            <i class="inline-block h-6 w-6 mask mask-calendar bg-success"></i>
                            <span class="font-bold text-secondary" id="dateretour"> {{ bouteille.date_retour_prevue |
                                dateFormat }}</span>
                        </div>
                        <hr class=" border-gray-300">
                    </div>
                </div>

                <!-- Boutons d’action -->
                <div class="mt-6 flex flex-col items-start space-y-3 w-full max-w-xs">
                    <div id="showMap" style="opacity: 0">
                        <div id="displayMap" ref="displayMap"></div>
                    </div>

                    <a v-if="bouteille.otag !== null" href="javascript: void 0"
                        class="inline-flex items-center px-4 py-2 bg-white text-black font-semibold rounded-lg shadow text-lg w-full border border-success localisation"
                        @click.prevent="toggleMap">
                        <i class="inline-block h-6 w-6 mask mask-map bg-success mr-2"></i>
                        Localiser la bouteille
                    </a>
                    <a v-if="!this.isRestit && this.bouteille.actif === true && this.bouteille.otag === null"
                        class="inline-flex items-center px-4 py-2 bg-white text-black font-semibold rounded-lg shadow text-lg w-full otag" :href="`fi360://scan?success=tryGoTo&bouteille=${bouteille.id}`">
                        <i class="inline-block h-6 w-6 mask mask-otag bg-success mr-2"></i>
                        <p>Ajouter une otag</p>
                    </a>

                    <a v-if="bouteille.type === 'Fluide frigorigène' && bouteille.actif === true"
                        class="inline-flex items-center px-4 py-2 bg-success text-white font-semibold rounded-lg shadow text-lg w-full" @click.prevent="goToRegul">
                        <i class="inline-block h-6 w-6 mask mask-reload bg-white mr-2"></i>
                        <span>Régulariser</span>
                    </a>

                    <div class="inline-flex items-center justify-start px-4 py-2 bg-white text-black border border-yellow-400 font-semibold rounded-lg shadow text-lg w-full favori"
                        @click="addThisBottleToFavorite"
                        v-if="!this.bouteille.favori || (this.bouteille.favori && this.bouteille.favori.id !== this.$user.id)">
                        <i class="inline-block h-5 w-5 mask mask-star bg-yellow-400 mr-2"></i>
                        <span>Ajouter aux favoris</span>
                    </div>

                    <div class="inline-flex items-center justify-start px-4 py-2 bg-yellow-400 text-black border border-yellow-400 font-semibold rounded-lg shadow text-lg w-full favori"
                        @click="removeThisBottleToFavorite" v-else>
                        <i class="inline-block h-5 w-5 mask mask-star bg-white mr-2"></i>
                        <span>Supprimer des favoris</span>
                    </div>
                </div>


                <div v-if="operations.length > 0" class="mt-6 bg-white rounded-lg shadow overflow-hidden mb-25">
                    <h3 class="text-xl text-secondary font-normal p-3">Historique bouteille</h3>

                    <table class="w-full border-collapse">
                        <tbody>
                            <tr class="border-y border-gray-200 odd:bg-[#F7F9FC]" v-for="op in operations" :key="op.id"
                                v-show="showHistory" :class="getOpClass(op.type)">
                                <td class="p-2 sm:p-3 text-center align-middle text-xs sm:text-sm"
                                    :class="op.type.includes('Retrait') ? 'text-gris' : 'text-secondary'">
                                    <i class="block mx-auto h-5 w-5 sm:h-6 sm:w-6 mask mb-0.5"
                                        :class="op.type.includes('Retrait') ? 'bg-gris mask-goutte-moins' : 'bg-secondary mask-goutte-plus'"></i>
                                    {{ op.type }}
                                </td>
                                <td class="p-2 sm:p-3 text-left align-middle text-xs sm:text-sm">
                                    <p>{{ op.user }}</p>
                                    <p class="font-bold">{{ op.date | dateFormat }}</p>
                                </td>
                                <td class="p-2 sm:p-3 text-right align-middle font-bold text-xs sm:text-sm">
                                    {{ op.quantite }} Kg
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

    </main-layout>
</template>

<script>

import Bouteille from '../../js/models/Bouteille'
import OperationBouteille from '../../js/models/OperationBouteille'
import Scan from "../../js/models/Scan"
import Synchro from '../../js/core/Synchro'
import User from "@/js/models/User";

export default {

    data() {

        return {
            bouteille: {},
            operations: [],
            scan: null,
            showHistory: true,
            usrScan: null,
            dateScan: null,
            historiques: [],
        }

    },

    methods: {

        addThisBottleToFavorite() {

            let userFavoriWithThisBottle = this.bouteille.favori;

            User.getUserData(user => {
                const sameUser = userFavoriWithThisBottle !== null && userFavoriWithThisBottle.id === user.id;

                const getFullName = (u) => `${u.last_name} ${u.first_name}`;

                const confirmAndUpdate = () => {
                    let bout = this.bouteille;
                    bout.favori = user;

                    Bouteille.updateBouteille(bout.id, bout)
                        .then(() => swal('Bouteille favorite', 'La bouteille a bien été ajoutée à vos favoris', 'success'))
                        .catch(err => {
                        });
                };

                if (userFavoriWithThisBottle !== null) {
                    if (sameUser) {
                        return swal({
                            title: 'Bouteille favorite',
                            text: 'Cette bouteille est déjà dans vos favoris',
                            type: 'info',
                            showCancelButton: false,
                            confirmButtonText: 'Ok',
                        });
                    } else {
                        return swal({
                            title: 'Bouteille favorite',
                            html: `Cette bouteille est la bouteille favorite de <strong>${getFullName(userFavoriWithThisBottle)}</strong>. Voulez-vous la mettre dans vos favoris ? <br>Cela retirera la bouteille de ces favoris.`,
                            type: 'question',
                            showCancelButton: true,
                            confirmButtonText: 'Oui',
                            cancelButtonText: 'Non',
                        }).then(res => {
                            if (res === true) confirmAndUpdate();
                        });
                    }
                }

                return swal({
                    title: 'Bouteille favorite',
                    text: 'Voulez-vous ajouter cette bouteille à vos favoris ?',
                    type: 'question',
                    showCancelButton: true,
                    confirmButtonText: 'Oui',
                    cancelButtonText: 'Non',
                }).then(res => {
                    if (res === true) confirmAndUpdate();
                });
            });

        },

        removeThisBottleToFavorite() {

            User.getUserData(user => {
                if (user.id === this.bouteille.favori.id) {
                    return swal({
                        title: 'Bouteille favorite',
                        html: `Voulez-vous retirer cette bouteille de vos favoris ?`,
                        type: 'question',
                        showCancelButton: true,
                        confirmButtonText: 'Oui',
                        cancelButtonText: 'Non',
                    }).then(res => {
                        if (res === true) {
                            let bout = this.bouteille;
                            bout.favori = {
                                'id': null
                            }
                            Bouteille.updateBouteille(bout.id, bout)
                                .then(() => swal('Bouteille favorite', 'La bouteille a bien été retirée de vos favoris', 'success'))
                                .catch(err => {
                                });
                        }
                    });
                }
            });
        },

        fetchBouteilleData() {

            return new Promise((resolve, reject) => {

                let idBout = this.$route.params.id;

                Bouteille
                    .getBouteille(idBout)
                    .then(data => {
                        this.bouteille = data;
                        resolve(data)
                    })
                    .catch(err => reject(err))

            })

        },

        fetchHistoriqueBouteille() {
            let idBout = this.$route.params.id;
            Bouteille
                .getAllScanByBouteilles(idBout)
                .then(scans => {
                    this.historiques = scans
                })

        },

        fetchOperations() {

            let op = new OperationBouteille;
            let idBout = this.$route.params.id;
            op.getOpsForBouteille(idBout).then(data => {
                this.operations = data
            })

        },

        infoManip(id) {
            if (id === 1) {
                return 'vierge'
            } else if (id === 2) {
                return 'recyclé'
            } else if (id === 3) {
                return 'régénéré'
            } else if (id === 4) {
                return 'déchet'
            } else if (id === 5) {
                return 'réutilisation'
            } else if (id === 6) {
                return 'régul'
            } else if (id === 7) {
                return 'regul'
            } else {
                return 'N/A'
            }
        },

        fetchScans() {

            Scan
                .getLastScanForBouteille(this.$route.params.id)
                .then(res => {
                    if (res !== undefined) {

                        this.scan = res;
                        this.dateScan = moment(res.created_at).format('DD/MM/YY HH:mm');

                        localforage.getItem('listUsers').then(usrs => {
                            let lstUsrs = JSON.parse(usrs);

                            if (res.user) {
                                this.usrScan = lstUsrs.filter(usr => {
                                    if (usr.id === res.user.id) {
                                        return usr
                                    }
                                })


                            } else {
                                this.usrScan = [{ nom: '' }]
                            }

                        })

                    }
                })
                .catch()

        },

        getOpClass(type) {
            let back = '';
            let inverse = _.includes(type.toLowerCase(), 'régularisation');

            if (_.includes(type.toLowerCase(), 'ajout')) {
                back = inverse ? 'add regul' : 'remove'
            } else {
                back = inverse ? 'remove regul' : 'add'
            }

            return back;
        },

        getPoidsBrut(val1, val2) {
            return (val1 + val2).toFixed(2)
        },

        async modifBouteilleStatus() {
            let idB = this.$route.params.id;
            if (!_.includes(idB, 'N-')) {
                idB = parseInt(idB)
            }

            if (this.bouteille.actif) {
                let isReutilisable = await Bouteille.isReutilisable(idB);

                if (isReutilisable === true) {
                    return swal('Fluide pour réutilisation', 'Attention Bouteille contenant du Fluide pour <strong>réutilisation</strong>.<br> Elle ne peut être rendue en l\'état sur <strong>TRACKDECHETS</strong>. Contactez la personne qui gère F.i360° dans votre entreprise avant de rendre cette bouteille.', 'info');
                }
                Bouteille.close(idB, this.bouteille)

            } else {
                let test = await Bouteille.isRendable(idB);
                let isReutilisable = await Bouteille.isReutilisable(idB);
                let isFluidFrigo = await Bouteille.isFluidFrigo(idB);
                let checkTdProblem = await Bouteille.checkTdProblem(idB);


                if (checkTdProblem.length > 0) {
                    let htmlMsg = "Le(s) détenteur(s) : <br><ul>";

                    checkTdProblem.forEach(detName => {
                        htmlMsg += "<li>" + detName + "</li>";
                    });

                    htmlMsg += "</ul> ne sont pas conforme à TrackDéchets. <br><br>Contactez la personne qui gère F.i360° dans votre entreprise avant de rendre cette bouteille.";

                    return swal({
                        title: 'Erreur',
                        html: htmlMsg,
                        type: 'error',
                        showConfirmButton: false,
                        showCancelButton: true,
                        cancelButtonText: "Ok",
                        confirmButtonText: "Ok"
                    }).catch(function (err) {
                        if (err == "cancel") {
                            if (navigator.onLine) {
                                Synchro.syncDetenteurs(true);
                            }
                        }
                    })
                }



                if (this.bouteille.poids_net == 0) {
                    //Force en frigo si la bouteille est vide, parce que osef, pas de transporteur, pas de td...
                    isFluidFrigo = true;
                }

                if (isReutilisable === false && isFluidFrigo === false && (localStorage.getItem('activateTrackDechets') === 'true')) {
                    let detenteurIsOk = await Bouteille.getDetenteurIsOk(idB);

                    if (detenteurIsOk.isOk === false) {

                        let htmlMsg = "Le(s) détenteur(s) : <br><ul>";

                        detenteurIsOk.detNom.forEach(detName => {
                            htmlMsg += "<li>" + detName + "</li>";
                        });

                        htmlMsg += "</ul> ne sont pas conforme à TrackDéchets. <br><br>Contactez la personne qui gère F.i360° dans votre entreprise avant de rendre cette bouteille.";

                        return swal({
                            title: 'Erreur',
                            html: htmlMsg,
                            type: 'error',
                            showConfirmButton: false,
                            showCancelButton: true,
                            cancelButtonText: "Ok",
                            confirmButtonText: "Ok"
                        }).catch(function (err) {
                            if (err == "cancel") {
                                if (navigator.onLine) {
                                    Synchro.syncDetenteurs(true);
                                }
                            }
                        })
                    }
                }

                if (test === true) {

                    Bouteille
                        .restitution([idB], isReutilisable, isFluidFrigo)
                        .then(() => {
                            this.$router.push({ name: 'home' });
                            swal('Bouteille restituée', 'La bouteille a bien été rendue', 'success')
                        })
                        .catch()

                } else {
                    swal('Intervention en cours', 'Cette bouteille contient au moins une opération sur une fiche non clôturée, elle ne peut donc pas être rendue pour le moment', 'warning')

                }

            }
        },

        toggleHistoryUser() {
            let showHistoryUser = document.getElementById('showHistoryUser');
            showHistoryUser.style.display = (showHistoryUser.style.display === 'none') ? 'block' : 'none';
        },

        toggleMap() {
            if (this.scan !== null) {
                let showMap = document.getElementById('showMap');
                let displayMap = document.getElementById('displayMap');
                showMap.style.opacity = 1;

                displayMap.style.height = '210px';
                displayMap.style.width = '360px';
                displayMap.style.marginBottom = '10px';
                this.loadMap();
            } else {
                return swal('Aucun scan disponible', "", 'info')
            }
        },

        loadMap() {
            if (this.scan !== null) {
                //this.showMap = true;

                const lat = this.scan.lat;
                const lng = this.scan.lng;

                let codeBout = this.bouteille.code;
                let dateBout = this.dateScan;

                let usrScan;
                if (!this.usrScan[0].nom) {
                    usrScan = ''
                } else {
                    usrScan = 'Par ' + this.usrScan[0].nom;
                }


                let mapEl = document.getElementById('displayMap');

                let map = L.map(mapEl, {
                    center: [lat, lng],
                    zoom: 19,
                    zoomControl: false,
                })

                map.invalidateSize();

                let layer = L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    maxZoom: 19,
                });

                map.addLayer(layer);

                let contentString =
                    `<div id="content" style="overflow:hidden" >
                            <div id="siteNotice">
                            </div>
                            <h1 id="firstHeading" class="firstHeading" style="font-size:15px; font-weight:bold; margin-bottom:15px">Bouteille code : ${codeBout}</h1>
                            <div id="bodyContent">
                                <p>
                                    Scan : ${dateBout}  <br/>
                                    ${usrScan}
                                </p>
                            </div>
                        </div>`;

                delete L.Icon.Default.prototype._getIconUrl;
                L.Icon.Default.mergeOptions({
                    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
                    iconUrl: require("leaflet/dist/images/marker-icon.png"),
                    shadowUrl: require("leaflet/dist/images/marker-shadow.png")
                });

                let marker = L.marker([lat, lng], {
                    html: contentString
                }).addTo(map);

                map.setView([lat, lng]);

                marker.bindPopup(contentString, {
                    className: 'custom-popup'
                })



            } else {
                swal('Aucun scan disponible', "", 'info')
            }


        },

        toggleHistory() {
            this.showHistory = (!this.showHistory);
        },

        goToRegul() {
            swal({
                title: 'Information',
                html: 'Si vous avez confondu <strong>Poids BRUT</strong> et <strong>Poids total de fluide</strong>,<br>Ne pas utiliser ce bouton.<br><br>La correction se fait depuis l\'interface FI360 en modifiant le poids initial de fluide.',
                type: 'info',
                showCancelButton: false,
                confirmButtonText: 'Compris',
            }).then(() => {
                this.$router.push({ name: 'bouteille-regul', params: { id: this.bouteille.id } });
            });
        }


    },

    computed: {

        shortTypeName: function () {
            let type = this.bouteille.type;

            return type.substring(0, 1).toLowerCase()
        },

        computedHeight: function () {
            let ratio = 200 * this.bouteille.poids_net / this.bouteille.poids_max;
            return 'height : ' + ratio + 'px;'
        },

        refLivraisonTruncate() {
            if (typeof this.bouteille.ref_livraison != "undefined") {
                if (this.bouteille.ref_livraison === null) {
                    return null;
                } else if (this.bouteille.ref_livraison.length > 25) {
                    return this.bouteille.ref_livraison.substring(0, 25) + '...';
                } else {
                    return this.bouteille.ref_livraison;
                }
            }

            return null;

        },

        isRestit() {
            if (!this.bouteille.actif && this.bouteille.restitution) {
                return true
            }
        }

    },

    mounted: function () {

        this
            .fetchBouteilleData()
            .then(data => {
                if (this.$route.query.scan) {
                    Scan.addOfflineScanBouteille(data.id)
                }
                if (this.$route.query.addOtag) {
                    swal('Bouteille modifiée', 'La bouteille a bien été modifiée', 'success');
                }

                let filled = 0;

                if (data.poids_net !== null && data.poids_max !== null) {
                    filled = Math.ceil((data.poids_net * 80) / data.poids_max);
                }

                const headroom = 20; // ex: 8% laissé vide en haut
                let effectiveFill = Math.max(0, Math.min(filled, 100 - headroom));

                effectiveFill = (effectiveFill * 94) / 100 + 6;

                effectiveFill = Math.abs(effectiveFill - 100);

                const item = document.createElement('div');
                item.classList.add('absolute', 'right-0', 'top-[20%]', 'md:top-[15%]');

                item.innerHTML = `
                    <svg version="1.2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 158 500" class="h-[250px] md:h-[400px]">
                        <defs>
                            <linearGradient id="halfColor" x1="0%" y1="0%" x2="0%" y2="100%">
                                <stop offset="0%" stop-color="#d4dded" />
                                <stop offset="${effectiveFill}%" stop-color="#d4dded" />
                                <stop offset="${effectiveFill}%" stop-color="#488AED" />
                                <stop offset="100%" stop-color="#1A469D" />
                                <animate attributeName="y1" from="100%" to="0%" dur="3s" fill="freeze" repeatCount="1" />
                            </linearGradient>
                        </defs>
                        <path fill="url(#halfColor)"
                            d="M80.9 97.6v-75.2h-15.7v-22.4h228.6v22.4h-15.7v75.2c45.6 0 80.9 37.5 80.9 83.3v188c0 45.8-31.2 83.3-76.9 83.3v22.4h19.8c2.2 0 4 1.8 4 4.1v21.3h-252.8v-21.3c0-2.3 1.8-4.1 4-4.1h19.8v-22.4c-45.7 0-76.9-37.5-76.9-83.3v-188c0-45.8 35.3-83.3 80.9-83.3zm167.4 371.1h22.5c2.6 0 4.8-2.4 4.8-5.4 0-2.9-2.2-5.3-4.8-5.3h-22.5c-2.6 0-4.8 2.4-4.8 5.3 0 3 2.2 5.4 4.8 5.4zm-40 0h22.5c2.6 0 4.7-2.4 4.7-5.4 0-2.9-2.1-5.3-4.7-5.3h-22.5c-2.6 0-4.8 2.4-4.8 5.3 0 3 2.1 5.4 4.8 5.4zm-40 0h22.4c2.7 0 4.8-2.4 4.8-5.4 0-2.9-2.1-5.3-4.8-5.3h-22.4c-2.7 0-4.8 2.4-4.8 5.3 0 3 2.1 5.4 4.8 5.4zm4-387.2v-30.2h-13.1v-12.9h45.2v12.9h-13.1v12.6h18.3v-7.7h12.5v24.6h-12.5v-7.7h-18.3v8.4h13.1v12h30.4c13.4 0 24.2-10.9 24.2-24.4v-18.3c0-13.5-10.8-24.4-24.2-24.4h-110.6c-13.4 0-24.3 10.9-24.3 24.4v18.3c0 13.5 10.9 24.4 24.3 24.4h35v-12h13.1zm-44.1 387.2h22.5c2.6 0 4.8-2.4 4.8-5.4 0-2.9-2.1-5.3-4.7-5.3h-22.5c-2.6 0-4.7 2.4-4.7 5.3 0 3 2.1 5.4 4.7 5.4zm-40 0h22.5c2.6 0 4.8-2.4 4.8-5.4 0-2.9-2.2-5.3-4.8-5.3h-22.5c-2.6 0-4.8 2.4-4.8 5.3 0 3 2.2 5.4 4.8 5.4z" />
                    </svg>
`;

                document.getElementById('bottle_page').prepend(item);


            })
            .catch();

        this.fetchOperations();

        this.fetchScans();

        if (navigator.onLine) {
            //this.fetchHistoriqueBouteille();
        }




    },
}

</script>

<style scoped>
@import '~leaflet/dist/leaflet.css';
</style>

<style>
.custom-popup {
    max-width: 300px;
    /* Largeur maximale de la popup */
    height: auto;
    /* Hauteur automatique en fonction du contenu */
    padding: 10px;
    /* Espace intérieur de la popup */
    font-size: 11px !important;
}
</style>



// WEBPACK FOOTER //
// Bouteille.vue?77f6737a